
import  {
  ProjectStatuses
} from '@resolve-ai/shared';

export const STATUS_STYLES: Record<string, string> = {
  [ProjectStatuses.ACTIVE]: "bg-success-DEFAULT",
  [ProjectStatuses.INACTIVE]: "bg-warning-DEFAULT",
  [ProjectStatuses.ARCHIVED]: "bg-gray-400",
};